import { useEffect, useRef, useState } from "react";

import QRCode from "qrcode.react";
import toast from "react-hot-toast";
import { useHistory, useLocation } from "react-router-dom";

import { useEnrollment } from "@ip-hooks/mfa";
import { publicPath } from "@ip-utils";
import { trackEvent } from "@ip-utils";
import { ButtonWithLoadingIcon } from "@ip-widgets/Tailwind/common/button";
import { DividerWithLabel } from "@ip-widgets/Tailwind/common/divider";
import { InputOutlined } from "@ip-widgets/Tailwind/common/input";
import component from "@ip-widgets/Tailwind/mfa/styled-components";

export default function OtpEnrollment() {
  const otpInputEl = useRef<HTMLInputElement>();
  const [, setCanContinue] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const history = useHistory();

  const query = new URLSearchParams(useLocation().search);
  const barcode_uri = query.get("barcode_uri");

  const { confirmOTP } = useEnrollment();

  useEffect(() => {
    function setIsEnrollingToFalse(e: any) {
      trackEvent("MFA", "Cancel enrollment");
      localStorage.setItem("isEnrolling", "false");
    }

    window.addEventListener("beforeunload", setIsEnrollingToFalse);

    return () =>
      window.removeEventListener("beforeunload", setIsEnrollingToFalse);
  }, []);

  useEffect(() => {
    function setIsEnrollingToFalse(e: any) {
      trackEvent("MFA", "Cancel enrollment");
      localStorage.setItem("isEnrolling", "false");
    }

    window.addEventListener("popstate", setIsEnrollingToFalse);

    return () => window.removeEventListener("popstate", setIsEnrollingToFalse);
  }, []);

  const cancelEnrollment = () => {
    trackEvent("MFA", "Cancel enrollment");

    localStorage.setItem("isEnrolling", "false");

    history.push("/security");
  };

  const confirmOTPEnrollment = async () => {
    if (!otpInputEl?.current?.value) {
      return;
    }
    const binding_code = otpInputEl.current.value;

    trackEvent("MFA", "Confirm enrollment");

    setLoading(true);
    const res = await confirmOTP(binding_code);
    setLoading(false);

    if (res.status === 200) {
      trackEvent("MFA", "Successful enrollment");
      setSuccess(true);

      toast.success("Success");

      setTimeout(() => {
        toast.loading("Redirecting");
      }, 2000);

      setTimeout(() => {
        history.push(`/security`);
        toast.dismiss();
      }, 3000);
    } else {
      const { error_description } = await res.json();
      toast.error(error_description);
      setError(true);
    }
  };

  const handleTextFieldOnChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const {
      target: { value },
    } = event;
    if (value.length > 0) {
      setCanContinue(true);
    } else {
      setCanContinue(false);
    }
  };

  if (!barcode_uri) {
    return <div>Loading</div>;
  }
  return (
    <component.SPage>
      <component.SContainer>
        <component.SHeaderContainer>
          <component.SImage src={publicPath("/media/iglu-white.svg")} />
        </component.SHeaderContainer>
        <component.SBodyContainer>
          <component.SHeader>Secure Your Account</component.SHeader>

          <component.SDescription>
            Scan the QR code with your preferred authenticator app and enter
            your generated One-time Password.
            <br />
            <a
              href="https://itunes.apple.com/us/app/raivo-otp/id1459042137"
              target="_blank"
              rel="noopener external noreferrer"
            >
              <component.SStoreButton
                src={publicPath("/media/app_store.svg")}
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=org.shadowice.flocke.andotp"
              target="_blank"
              rel="noopener external noreferrer"
            >
              <component.SStoreButton
                src={publicPath("/media/play_store.svg")}
              />
            </a>
            <br />
          </component.SDescription>

          <component.SQRContainer>
            <QRCode value={barcode_uri} renderAs="svg" level="Q" size={146} />
          </component.SQRContainer>

          <div
            style={{
              width: "100%",
              marginBottom: 24,
            }}
          >
            <DividerWithLabel label="THEN" />
          </div>

          <InputOutlined
            id="otp-input"
            onChange={handleTextFieldOnChange}
            placeholder="XXX XXX"
            inputRef={otpInputEl}
            autoFocus
          />

          <ButtonWithLoadingIcon
            text="Continue"
            size="lg"
            loading={loading}
            success={success}
            error={error}
            onClick={confirmOTPEnrollment}
            style={{ width: "100%", marginTop: 24 }}
          />

          <ButtonWithLoadingIcon
            text="Cancel enrollment"
            size="lg"
            onClick={cancelEnrollment}
            style={{ width: "100%", marginTop: 24, background: "#DC2626" }}
          />
        </component.SBodyContainer>
      </component.SContainer>
    </component.SPage>
  );
}
